import { Injectable } from '@angular/core';
import { NgDialogAnimationService } from 'src/app/services/core/ng-dialog-animation.service';
import { ConfirmationPopupComponent } from '../../modules/shared/confirmation-popup/confirmation-popup.component';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private dialogRef: any;

  /*private config: any = {
    width: '500px',
    animation: {
      to: 'left',
      incomingOptions: {
        keyframeAnimationOptions: { duration: 700, easing: 'steps(100, end)' }
      }
    },
    position: { rowStart: '0' }
  };*/

  public config: any = {
    width: '900px',
    data: {},
    animation: {
      to: 'left',
      incomingOptions: {
        keyframeAnimationOptions: { duration: 700, easing: 'steps(100, end)' },
      },
    },
    position: { rowStart: '0' },
  };

  constructor(public dialog: NgDialogAnimationService) {}

  getDialogConfigs = () => {
    return this.config;
  };

  public onOpenMediumDialog = (component: any, data: any = {}) => {
    this.onOpenFromRightDialog(component, data, 700);
  };

  public onOpenFromRightDialog = (
    component: any,
    data: any = {},
    width: number = 900
  ) => {
    this.dialogRef = this.dialog.open(component, {
      disableClose: true,
      width: `${width}px`,
      height: '100%',
      data: data,
      autoFocus: false,
      animation: {
        to: 'left',
        incomingOptions: {
          keyframeAnimationOptions: {
            duration: 700,
            easing: 'steps(100, end)',
          },
        },
      },
      position: { rowStart: '0' },
    });

    /* const sub = dialogRef?.componentInstance?.onAdd.subscribe((data: any) => {
      //this.getData();
      //this.closeDialog();
    });*/

    /*this.dialogRef?.afterClosed().subscribe((result: any) => {
      console.log(result, 'Inside Here');
     // sub.unsubscribe();
    });*/
    return this.dialogRef;
  };

  public onOpenPopUpDialog = (
    component: any,
    data: any = {},
    width: number = 950,
    height: number = 900
  ) => {
    this.dialogRef = this.dialog.open(component, {
      disableClose: true,
      width: `${width}px`,
      height: `${height}px`,
      data: data,
      autoFocus: false,
      position: { top: '4%', left: '30%' }, // Center the dialog
    });
  };

  public onOpenStaffTerminatePopUpDialog = (
    component: any,
    data: any = {},
    width: number = 700,
    height: number = 450
  ) => {
    this.dialogRef = this.dialog.open(component, {
      disableClose: true,
      width: `${width}px`,
      height: `${height}px`,
      data: data,
      autoFocus: false,
      position: { top: '15%', left: '30%' }, // Center the dialog
    });
  };

  public onOpenStaffChangePassPopUpDialog = (
    component: any,
    data: any = {},
    width: number = 700,
    height: number = 580
  ) => {
    // Close any existing dialog first
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    // Determine panelClass based on component
    let panelClass = '';
    // Check if component is ChangePasswordComponent
    // Using multiple checks for reliability across dev/prod builds
    const componentName = component?.name || component?.toString() || '';
    const constructorName = component?.prototype?.constructor?.name || '';
    if (
      componentName.includes('ChangePassword') ||
      constructorName.includes('ChangePassword')
    ) {
      panelClass = 'change-password-dialog-container';
    }

    const dialogConfig: any = {
      disableClose: true,
      width: `${width}px`,
      maxWidth: `${width}px`,
      maxHeight: '80vh',
      data: data,
      autoFocus: false,
    };

    if (panelClass) {
      dialogConfig.panelClass = panelClass;
    } else {
      dialogConfig.position = { top: '15%', left: '30%' }; // Center the dialog for other components
    }

    this.dialogRef = this.dialog.open(component, dialogConfig);
  };

  public onOpenDialog = (
    component: any,
    data: any = {},
    width: number = 900,
    minHeight: any = ''
  ) => {
    const configurations: any = {
      disableClose: true,
      width: `${width}px`,
      maxHeight: '98vh',
      minHeight: minHeight,
      autoFocus: false,
      data: data,
      position: { rowStart: '0' },
    };

    // Center confirmation popup like other centered modals
    if (component === ConfirmationPopupComponent) {
      configurations.width = '500px';
      configurations.position = { top: '15%', left: '33%' };
      configurations.panelClass = 'centered-dialog';
    }

    // if (minHeight){
    //   configurations['minHeight'] = minHeight;
    // }
    this.dialogRef = this.dialog.open(component, configurations);

    /* const sub = dialogRef?.componentInstance?.onAdd.subscribe((data: any) => {
      //this.getData();
      //this.closeDialog();
    });*/

    /*this.dialogRef?.afterClosed().subscribe((result: any) => {
      console.log(result, 'Inside Here');
     // sub.unsubscribe();
    });*/
  };

  onClose = (data: any) => {
    this.dialogRef?.close(data);
  };

  /**
   * Close every open dialog and drop the retained ref.
   *
   * Dialogs are attached to the CDK overlay container on document.body, not
   * under <router-outlet>, so navigating away does not destroy them — on
   * sign-out they would otherwise stay on screen over the login page. Call
   * this before clearing the session and navigating.
   *
   * `dialogRef` is nulled because this service is a root singleton: it holds
   * the last opened dialog for the lifetime of the app, and a ref left over
   * from the previous session would leak into the next one.
   */
  closeAll = () => {
    this.dialog.closeAll();
    this.dialogRef = null;
  };
  getComponentInstance = () => {
    return this.dialogRef?.componentInstance;
  };

  afterClose = () => {
    return this.dialogRef?.afterClosed();
  };

  onConfirmation(): void {
    this.dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      height: '300px',
      disableClose: true,
      data: {},
    });

    /*dialogRef.afterClosed().subscribe(result => {
      if(result) {
       // this.onDelete();
      }
    });*/
  }

  /**
   * Show a single-button warning modal (shared ConfirmationPopupComponent
   * in warning style). Use to block an action and tell the operator what
   * to do first. Passing an empty cancelButtonText hides the second button.
   */
  warn(
    title: string,
    message: string,
    description: string = '',
    confirmButtonText: string = 'OK, got it'
  ): void {
    this.onOpenDialog(ConfirmationPopupComponent, {
      title,
      message,
      description,
      isWarning: true,
      confirmButtonText,
      cancelButtonText: '',
      confirmIcon: 'warning_amber',
    });
  }

  /**
   * Show confirmation dialog with title, message and callback
   */
  confirm(
    title: string,
    message: string,
    onConfirm?: () => void,
    onCancel?: () => void
  ): void {
    this.dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      width: '500px',
      height: '300px',
      disableClose: true,
      data: {
        title: title,
        message: message,
      },
    });

    this.dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result && onConfirm) {
        onConfirm();
      } else if (!result && onCancel) {
        onCancel();
      }
    });
  }
}
